import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface AdminCalendarEventsManagerProps {
  calendarEvents: any[];
  setCreatePanel: (panel: any) => void;
  handlePublishEvent: (id: number) => void;
  renderTableHeader: (title: string, count: number, onExport?: () => void, onCreate?: () => void, createLabel?: string) => React.ReactNode;
  generateCSV: (data: any[], name: string) => void;
}
export function AdminCalendarEventsManager({
  calendarEvents,
  setCreatePanel,
  handlePublishEvent,
  renderTableHeader,
  generateCSV
}: AdminCalendarEventsManagerProps) {
  return <div className="space-y-4" data-id="element-2506">
      {renderTableHeader('Календарь событий', calendarEvents.length, () => generateCSV(calendarEvents, 'events'), () => setCreatePanel({
      type: 'event',
      title: 'Добавить событие'
    }), 'Добавить')}
      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-2507">
        <table className="w-full text-left" data-id="element-2508">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-2509">
            <tr data-id="element-2510">
              <th className="px-3 py-2" data-id="element-2511">Событие</th>
              <th className="px-3 py-2" data-id="element-2512">Дата</th>
              <th className="px-3 py-2" data-id="element-2513">Тип</th>
              <th className="px-3 py-2" data-id="element-2514">Статус</th>
              <th className="px-3 py-2" data-id="element-2515"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-2516">
            {calendarEvents.map(e => <tr key={e.id} className="hover:bg-slate-50" data-id="element-2517">
                <td className="px-3 py-2 text-sm font-medium" data-id="element-2518">{e.title}</td>
                <td className="px-3 py-2 text-sm" data-id="element-2519">{e.date}</td>
                <td className="px-3 py-2 text-xs text-slate-500" data-id="element-2520">{e.type}</td>
                <td className="px-3 py-2" data-id="element-2521">
                  <Badge variant={e.status === 'published' ? 'success' : 'neutral'} size="sm" data-id="element-2522">
                    {e.status === 'published' ? 'Опубликовано' : 'Черновик'}
                  </Badge>
                </td>
                <td className="px-3 py-2 text-right" data-id="element-2523">
                  {e.status !== 'published' && <Button variant="ghost" size="sm" onClick={() => handlePublishEvent(e.id)} data-id="element-2524">
                      Опубликовать
                    </Button>}
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
}